import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import WorkOrder from '../../interfaces/WorkOrder.interface';

interface WorkOrdersState {
  workOrders: WorkOrder[];
}

interface SetWorkOrdersPayload {
  workOrders: WorkOrder[];
}

interface UpdateArchiveStatusOfManyPayload {
  ids: string[];
  archiveReason: string;
  isArchived: boolean;
}

interface UpdateWorkOrderPayload {
  changedWorkOrder: WorkOrder;
}

export const initialState: WorkOrdersState = {
  workOrders: []
};

const workOrdersSlice = createSlice({
  name: 'workOrders',
  initialState,
  reducers: {
    setWorkOrders(state, action: PayloadAction<SetWorkOrdersPayload>) {
      state.workOrders = action.payload.workOrders;
    },
    updateOneWorkOrder(state, action: PayloadAction<UpdateWorkOrderPayload>) {
      const { changedWorkOrder } = action.payload;
      const { workOrders } = state;
      const changedWOIndex = workOrders.findIndex(wo => wo.id === changedWorkOrder.id);
      state.workOrders[changedWOIndex] = changedWorkOrder;
    },
    updateArchiveStatusOfMany(state, action: PayloadAction<UpdateArchiveStatusOfManyPayload>) {
      const { ids } = action.payload;
      ids.forEach(id => {
        const index = state.workOrders.findIndex(wo => wo.id === id);
        state.workOrders.splice(index, 1);
      });
    }
  }
});

export const {
  setWorkOrders,
  updateOneWorkOrder,
  updateArchiveStatusOfMany
} = workOrdersSlice.actions;

export default workOrdersSlice.reducer;
